import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { FullScreenLoader, getAIRsDataQueryOptions, getInReviewDetailsQueryKey } from "shared-ui";
import { useCustomerAppConfig } from "undercarriage";

import { ConnectionAuthCallbackHandler } from "../../components";
import { FUNDING_APPLICATION_CONNECTORS_API } from "../../components/constants";
import { platformConnectorsQueryParams, useHandleAirConnection } from "../../hooks/air-connection";

export const OriginConnectionCallbackPage = ({
  airBasePath,
  returnPath,
}: {
  airBasePath: string;
  returnPath: string;
}) => {
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { handleSuccess: handleAirConnectionSuccess, handleError: handleAirConnectionError } = useHandleAirConnection({
    airBasePath,
  });

  return (
    <ConnectionAuthCallbackHandler
      onSuccess={async (args) => {
        const firstConnection = args.get("first-connection");

        await queryClient.invalidateQueries({
          queryKey: [
            FUNDING_APPLICATION_CONNECTORS_API.replace(":customerSlug", customerDomain),
            platformConnectorsQueryParams,
          ],
        });
        await handleAirConnectionSuccess(args);

        if (firstConnection === "False") {
          return;
        }

        await queryClient.invalidateQueries({
          queryKey: getInReviewDetailsQueryKey(customerDomain),
        });
        await queryClient.invalidateQueries({ queryKey: getAIRsDataQueryOptions(customerDomain).queryKey });
        navigate(`/${customerDomain}/${returnPath}`, { replace: true });
      }}
      onError={handleAirConnectionError}
    >
      <FullScreenLoader />
    </ConnectionAuthCallbackHandler>
  );
};
